import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const MidFunnelCity = loadable(() => import('./MidFunnelCity'));

MidFunnelCity.getInitialState = getInitialState;

export default MidFunnelCity;
